import BudgetInvestmentProjectsCard from "../pages/indicators/components/cards/budget-investment-projects-card.component"
import FoodCard from "../pages/indicators/components/cards/food-card.component"
import InfrastructureCard from "../pages/indicators/components/cards/infrastructure-card.component"
import MediaMonitoringCard from "../pages/indicators/components/cards/media-monitoring-card.component"
import PopulationDemandCard from "../pages/indicators/components/cards/population-demand-card.component"
import PopulationDynamicCard from "../pages/indicators/components/cards/population-dynamic.component"
import PsdCard from "../pages/indicators/components/cards/psd-card.component"
import RoadCard from "../pages/indicators/components/cards/road-card.component"
import SerCard from "../pages/indicators/components/cards/ser-card.component"
import TaxCard from "../pages/indicators/components/cards/tax-card.component"
import { ICardName, IKatoTreeItem, KatoType } from "../types/kato.types"

export const oblast: IKatoTreeItem = {
    kato: 150000000,
    nameRu: "Актюбинская область",
    nameKz: "Ақтөбе облысы",
    type: KatoType.OBLAST
}

export const city: IKatoTreeItem = {
    kato: 151010000,
    nameRu: "Актобе г.а.",
    nameKz: "Ақтөбе қ.ә.",
    type: KatoType.CITY
}

export const oblastCards: ICardName[] = [
    ICardName.SER,
    ICardName.PSD,
    ICardName.POPULATION_DYNAMIC,
    ICardName.BUDGET_INVESTMENT_PROJECTS,
    ICardName.FOOD,
    ICardName.INFRASTRUCTURE,
    ICardName.ROAD,
    ICardName.TAX,
    ICardName.POPULATION_DEMAND,
    ICardName.MEDIA_MONITORING,
]

export const districtCards: ICardName[] = [
    ICardName.FOOD,
    ICardName.POPULATION_DEMAND,
    ICardName.POPULATION_DYNAMIC,
    ICardName.BUDGET_INVESTMENT_PROJECTS,
    ICardName.INFRASTRUCTURE
]

export const getCardByName = (name: ICardName): React.ReactNode => {
    switch (name) {
        case ICardName.SER:
            return <SerCard />;
        case ICardName.PSD:
            return <PsdCard />;
        case ICardName.POPULATION_DYNAMIC:
            return <PopulationDynamicCard />;
        case ICardName.BUDGET_INVESTMENT_PROJECTS:
            return <BudgetInvestmentProjectsCard />;
        case ICardName.FOOD:
            return <FoodCard />;
        case ICardName.INFRASTRUCTURE:
            return <InfrastructureCard />;
        case ICardName.ROAD:
            return <RoadCard />;
        case ICardName.TAX:
            return <TaxCard />;
        case ICardName.POPULATION_DEMAND:
            return <PopulationDemandCard />;
        case ICardName.MEDIA_MONITORING:
            return <MediaMonitoringCard />;
        default:
            return <></>;
    }
}

export const aktobeDistrictsWithNames = [
    { kato: 153400000, coordinates: [61.1, 50.1], nameRu: "Айтеке би" }, //Айтеке би
    { kato: 153220000, coordinates: [57.3, 49.9], nameRu: "Алга" }, // Алга
    { kato: 153600000, coordinates: [56.4, 47.4], nameRu: "Байганин" }, // Байганин
    { kato: 156800000, coordinates: [62.1, 48.6], nameRu: "Иргиз" }, // Иргиз
    { kato: 154000000, coordinates: [58.2, 50.8], nameRu: "Каргалы" }, // Каргалы
    { kato: 154600000, coordinates: [56.9, 50.7], nameRu: "Мартук" }, // Мартук
    { kato: 154800000, coordinates: [57.9, 49.3], nameRu: "Мугалжар" }, // Мугалжар
    { kato: 155600000, coordinates: [56.5, 49.1], nameRu: "Темир" }, // Темир
    { kato: 155200000, coordinates: [54.7, 49.1], nameRu: "Ойыл" }, // Ойыл
    { kato: 154200000, coordinates: [55.7, 50.2], nameRu: "Кобда" }, // Кобда
    { kato: 156000000, coordinates: [58.5, 50.2], nameRu: "Хромтау" }, // Хромтау
    { kato: 156400000, coordinates: [59.5, 47.4], nameRu: "Шалкар" }, // Шалкар
];

export const irgizDistrictsWithNames = [
    { kato: 156837000, coordinates: [63.12729181250001, 47.89945525030757], nameRu: "Жайсанбайский район" }, //Жайсанбайский
    { kato: 156845000, coordinates: [62.03964532812501, 48.334028909993684], nameRu: "Тауипский район" }, // Тауипский
    { kato: 156843000, coordinates: [62.49008478125001, 48.728708730877855], nameRu: "Нуринский район" }, // Нуринский
    { kato: 156839000, coordinates: [60.59768976171876, 49.19037030772027], nameRu: "Кумтогайский район" }, // Кумтогайский 11
    { kato: 156841000, coordinates: [60.49331964453126, 48.77760123427689], nameRu: "Кызылжарский район" }, // Кызылжарский 11
    { kato: 156830000, coordinates: [61.03439630468751, 48.77036090265034], nameRu: "Иргизский район" }, // Иргизский
    { kato: 156835000, coordinates: [61.49032892187501, 48.76492996868138], nameRu: "Аманкольский район" }, // Аманкольский
];